import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputBase from '@mui/material/InputBase';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import PropTypes from 'prop-types';
import ConstituentSortFields from '@/constants/constituents/ConstituentSortFields';
import SortOrder from '@/constants/SortOrder';
import translate from '@/lib/intl/translate';

const menuItems = [
  {
    value: [ConstituentSortFields.DISPLAY_NAME, SortOrder.ASC].join(','),
    label: translate('FORMS_SORT_A_Z'),
  },
  {
    value: [ConstituentSortFields.DISPLAY_NAME, SortOrder.DESC].join(','),
    label: translate('FORMS_SORT_Z_A'),
  },
  {
    value: [ConstituentSortFields.LAST_INTERACTION_DATE, SortOrder.DESC].join(
      ',',
    ),
    label: translate('CONSTITUENT_SORT_NEWEST'),
  },
  {
    value: [ConstituentSortFields.LAST_INTERACTION_DATE, SortOrder.ASC].join(
      ',',
    ),
    label: translate('CONSTITUENT_SORT_OLDEST'),
  },
];

function ConstituentSortSelect({ className, onChange, size, value }) {
  return (
    <FormControl variant="outlined" size={size} className={className}>
      <InputLabel>{translate('FORMS_SORT_BY')}</InputLabel>
      <Select
        value={value}
        className="w-full"
        name="sort"
        label={translate('FORMS_SORT_BY')}
        onChange={onChange}
        defaultValue={menuItems[0]}
        size={size}
      >
        {menuItems.map(({ label, value: val }) => (
          <MenuItem key={val} value={val}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

ConstituentSortSelect.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  size: InputBase.propTypes.size,
  value: PropTypes.string,
};

ConstituentSortSelect.defaultProps = {
  className: '',
  onChange: () => {},
  size: 'small',
  value: '',
};

export default ConstituentSortSelect;
